module.exports = __webpack_public_path__ + "media/images/bg-leaderboards-3d462833489044ec72d996b292b2bc8f.svg";